export function getDateFromTimestamp(timestamp) {
	var year = timestamp.substring(0, 4);
	var month = timestamp.substring(4, 6);
	var day = timestamp.substring(6, 8);
	var hours = timestamp.substring(9, 11);
	var minutes = timestamp.substring(12, 14);
	
	var date = new Date();
	date.setYear(parseInt(year, 10));
	date.setMonth(parseInt(month, 10)-1, parseInt(day, 10));
	date.setHours(parseInt(hours, 10));
	date.setMinutes(parseInt(minutes, 10));
	date.setSeconds(0);
	
	return date;
}
